"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.AuthProvider = exports.AuthContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var axiosHelper_1 = require("../functions/axiosHelper");
exports.AuthContext = React.createContext(new Object);
var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(localStorage.getItem("authToken")), token = _b[0], setToken = _b[1];
    var _c = React.useState([]), authList = _c[0], setAuthList = _c[1];
    var _d = React.useState(false), isPermissionLoaded = _d[0], setIsPermissionLoaded = _d[1];
    var _e = React.useState(new Object), user = _e[0], setUser = _e[1];
    var handleLogin = function (_a) {
        var email = _a.email, password = _a.password;
        return __awaiter(void 0, void 0, void 0, function () {
            var response, token_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, axiosHelper_1.postAxios)({
                            url: '/auth/login',
                            body: {
                                email: email,
                                password: password,
                                service: process.env.REACT_APP_SERVICE_NAME
                            }
                        }).then(function (res) {
                            return res;
                        })];
                    case 1:
                        response = _b.sent();
                        if (!response.error && response.data && response.data.authorization_token) {
                            token_1 = response.data.authorization_token;
                            localStorage.setItem("authToken", token_1);
                            setToken(token_1);
                            checkToken(token_1);
                            return [2 /*return*/, {
                                    success: true,
                                    token: token_1,
                                    expire_date: response.data.expire_date
                                }];
                        }
                        else {
                            return [2 /*return*/, {
                                    success: false,
                                    message: (response === null || response === void 0 ? void 0 : response.errorMessage) || 'Something went wrong get contact'
                                }];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleLogout = function () {
        localStorage.removeItem("authToken");
        setToken(null);
        window.location.href = '/sign-in';
    };
    var handleRedirectUrl = function () {
        var pathName = window.location.pathname;
        if (!pathName.includes('/sign-in')) {
            var now = new Date();
            var time = now.getTime();
            time += 900 * 1000;
            now.setTime(time);
            document.cookie =
                'redirectUrl=' + pathName +
                    '; expires=' + now.toUTCString() +
                    '; path=/';
        }
    };
    var checkToken = function (optionalToken) {
        if (optionalToken === void 0) { optionalToken = undefined; }
        return __awaiter(void 0, void 0, void 0, function () {
            var ignoreUrls, config, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ignoreUrls = process.env.REACT_APP_IGNORE_URLS;
                        // To make public accessible pages by environment variable
                        if (ignoreUrls && ignoreUrls.split(',').some(function (ignorePathe) { return window.location.pathname.includes(ignorePathe); })) {
                            return [2 /*return*/];
                        }
                        if (isPermissionLoaded) {
                            return [2 /*return*/];
                        }
                        if (!(token || optionalToken)) return [3 /*break*/, 2];
                        config = { headers: { Authorization: "Bearer ".concat(token || optionalToken) } };
                        return [4 /*yield*/, (0, axiosHelper_1.getAxios)({
                                url: '/auth/permissions?is_debug=true',
                                config: config
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.error) {
                            localStorage.removeItem("authToken");
                            handleRedirectUrl();
                            window.location.href = '/sign-in';
                        }
                        else {
                            setAuthList(response.data.permissions);
                            setUser(response.data.user);
                            document.cookie = 'redirectUrl=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            setIsPermissionLoaded(true);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        handleRedirectUrl();
                        window.location.href = '/sign-in';
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    React.useEffect(function () {
        checkToken();
    }, []);
    var value = {
        user: user,
        token: token,
        authList: authList,
        isPermissionLoaded: isPermissionLoaded,
        onLogin: handleLogin,
        onLogout: handleLogout
    };
    return ((0, jsx_runtime_1.jsx)(exports.AuthContext.Provider, __assign({ value: value }, { children: children })));
};
exports.AuthProvider = AuthProvider;
